import { useSelector } from "react-redux";

import { RootState } from "@/utils/store";
import { FC } from "react";
import styled from "styled-components";

export const TeamIcon = styled.img`
  border: 1px solid ${({ theme }) => theme.colors.white};
  width: 20px;
  height: 20px;
  object-fit: cover;
  border-radius: 50%;
`;

const TeamPlaceholder = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.white};
  width: 20px;
  height: 20px;
  background: ${({ theme }) => theme.colors.grayscaleLight};
  border-radius: 50%;
`;

interface Props {
  teamId: string;
}

const PerformanceCardTeam: FC<Props> = ({ teamId }) => {
  const team = useSelector((state: RootState) => state.teams[teamId]);

  return (
    <>
      {team?.icon?.versions?.icon ? (
        <TeamIcon src={team?.icon?.versions?.icon} alt={team?.name} />
      ) : (
        <TeamPlaceholder />
      )}
    </>
  );
};

export default PerformanceCardTeam;
